export const BASE_URLL = "http://localhost:5000/api/admin";
export const BASE_URL = "https://backend.cwisfsmsupportcell.org/api/admin";
export const BASE_DOC_URLL = "http://localhost:5000";
export const BASE_DOC_URL = "https://backend.cwisfsmsupportcell.org";
export const SECURE_STORAGE_KEY = "this is secure storage key";

export const UserTypeList = [
  { value: "admin", label: "ADMIN" },
  { value: "user", label: "USER" },
  { value: "visitor", label: "VISITOR" },
];

export const USER_CONTROLLER = "users";
export const COMPANY_CONTROLLER = "companies";
export const MENU_CONTROLLER = "menus";
export const SEMINAR_ALBUM_CONTROLLER = "seminar-albums";
export const PAGINATION_API = "pagination";
export const CHECK_AVAILABLE_USERNAME_API = "check-available-username";
export const DEFAULT_SORTING = [{ field: "created_at", order: "desc" }];

export const newsTypeList = [
  { label: "News", value: "news" },
  { label: "Blog", value: "blog" },
];

export const ProjectStatusList = [
  { label: "Not Started", value: "NOT_STARTED" },
  { label: "Planning", value: "PLANNING" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "On Hold", value: "ON_HOLD" },
  { label: "Under Review", value: "UNDER_REVIEW" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Cancelled", value: "CANCELLED" },
];

export const ProjectStatusColors = {
  NOT_STARTED: "#808080", // Gray
  PLANNING: "#87CEEB", // Sky Blue
  IN_PROGRESS: "#1E90FF", // Dodger Blue
  ON_HOLD: "#FFA500", // Orange
  UNDER_REVIEW: "#9370DB", // Medium Purple
  COMPLETED: "#32CD32", // Lime Green
  CANCELLED: "#FF0000", // Red
  DELAYED: "#FF6347", // Tomato
  TESTING: "#FFD700", // Gold
  MAINTENANCE: "#20B2AA", // Light Sea Green
};

export const ProjectStatusDescriptions = {
  NOT_STARTED: "Project has been created but work hasn't begun",
  PLANNING: "Project is in the planning and preparation phase",
  IN_PROGRESS: "Project is actively being worked on",
  ON_HOLD: "Project has been temporarily paused",
  UNDER_REVIEW: "Project is being reviewed by stakeholders",
  COMPLETED: "Project has been successfully completed",
  CANCELLED: "Project has been terminated before completion",
  DELAYED: "Project is behind schedule",
  TESTING: "Project is in the testing phase",
  MAINTENANCE: "Project is in maintenance mode",
};
